import { defineMessages } from 'react-intl';

export default defineMessages({
  addRepositoryDescriptionLink: {
    id: 'frontbucket.repository.source.addRepositoryDescriptionLink',
    description:
      'A link directed to repository settings in order to add a repository description',
    defaultMessage: 'add a description to your repository',
  },

  repositoryDescriptionPlaceholder: {
    id: 'frontbucket.repository.source.repositoryDescriptionPlaceholder',
    description:
      'The default or placeholder text displayed where the repository description would be if present',
    defaultMessage: `Here's where you'll find this repository's source files. To give your users an idea of what they'll find here, {addRepositoryDescriptionLink}.`,
  },

  keyboardShortcutGroup: {
    id: 'frontbucket.repository.source.keyboardShortcutGroup',
    description:
      'The title for the group of keyboard shortcuts for the source browser',
    defaultMessage: 'Source browser',
  },
});
